<template>
	<div>
		<div class="scenario-select-jishin">
			<select class="form-control" v-model="selected" @change="changeScenario">
				<option value="0">0：調べたい場所を探す</option>
				<option value="1">1：震度マップを見る</option>
				<option value="2">2：液状化マップを見る</option>
				<option value="3">3：現在と過去を比較</option>
				<option value="4">4：土地条件図を見る</option>
				<option value="5">5：震度と土地条件図</option>
				<option value="6">6：液状化と土地条件図</option>
				<option value="7">7：建物倒壊シミュレータ</option>
			</select>
		</div>
		<div class="scenario-btn">
			<button type="button" class="btn btn-primary" v-show="showBtnBack" @click="scenarioBack">←シナリオ戻る</button>
			<button type="button" class="btn btn-primary" v-show="showBtnGo" @click="scenarioGo">シナリオ進む→</button>
			<button type="button" class="btn btn-primary" v-show="showBtnGoSim" @click="simGo">建物倒壊シミュレータ（選択式）へ進む→</button>
		</div>
		<div class="map-label-l" v-show="showMapLabelL" @click="showLegendL">{{ mapLabelL }}</div>
		<div class="map-label-r" v-show="showMapLabelR" @click="showLegendR">{{ mapLabelR }}</div>
		<div class="scenario-text" v-html="scenarioText"></div>
		<GlobalEvents
			v-if="showBtnGo"
			@keydown.enter.exact="scenarioGo"
		/>
	</div>
</template>

<script>
import {JSFrame} from 'jsframe';
import GlobalEvents from 'vue-global-events';

const jsFrame = new JSFrame();
var legendWinL = null;
var legendWinR = null;

export default {
	components: {
		GlobalEvents
	},
	data() {
		return {
			selected: '0',
			showBtnBack: false,
			showBtnGo: true,
			showBtnGoSim: false,
			showMapLabelL: false,
			showMapLabelR: false,
			mapLabelL: '',
			mapLabelR: '',
			legendParamL: {
				title: '',
				size: [],
				url: '',
			},
			legendParamR: {
				title: '',
				size: [],
				url: '',
			}
		}
	},
	props: {
		'mapData': {
			type: Object
		},
		'mapData2': {
			type: Object
		}
	},
	methods: {
		changeScenario: function() {
			console.log('this.selected='+this.selected);
			if (legendWinL) {
				legendWinL.hide();
			}
			if (legendWinR) {
				legendWinR.hide();
			}
			switch (this.selected) {
				case '0':
					console.log('シナリオ0 selected');
					//シナリオボタンの表示制御
					this.showBtnBack = false;
					this.showBtnGo = true;
					this.showBtnGoSim = false;

					//一画面と二画面のモード切り替え
					this.$emit('changeDoubleScreen', 'OFF');

					//背景図切り替え
					this.$emit('changeLeftLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});

					//レイヤ切り替え
					this.$emit('changeLeftLayer', {value:'L100', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L110', display:false, checkedLayers:[], checkedAllLayers:[]});

					//地図ラベルの表示制御
					this.showMapLabelL = false;
					this.showMapLabelR = false;
					this.mapLabelL = '';
					this.mapLabelR = '';

					break;
				case '1':
					console.log('シナリオ1 selected');
					//シナリオボタンの表示制御
					this.showBtnBack = true;
					this.showBtnGo = true;
					this.showBtnGoSim = false;

					//一画面と二画面のモード切り替え
					this.$emit('changeDoubleScreen', 'OFF');

					//背景図切り替え
					this.$emit('changeLeftLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});

					//レイヤ切り替え
					this.$emit('changeLeftLayer', {value:'L110', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L100', display:true, checkedLayers:['L100'], checkedAllLayers:[]});

					//中心点のレイヤ属性取得
					this.$emit('centerGetLeft');

					//凡例ウィンドウの表示制御
					this.legendParamL.title = '震度凡例';
					this.legendParamL.size = [230, 230];
					this.legendParamL.url = 'legend/si.html';

					//地図ラベルの表示制御
					this.showMapLabelL = true;
					this.showMapLabelR = false;
					this.mapLabelL = '震度';
					this.mapLabelR = '';

					break;
				case '2':
					console.log('シナリオ2 selected');
					this.showBtnBack = true;
					this.showBtnGo = true;
					this.showBtnGoSim = false;

					this.$emit('changeDoubleScreen', 'OFF');
					this.$emit('changeLeftLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L100', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L110', display:true, checkedLayers:['L110'], checkedAllLayers:[]});
					this.$emit('centerGetLeft');

					this.legendParamL.title = '液状化危険度凡例';
					this.legendParamL.size = [230, 210];
					this.legendParamL.url = 'legend/pl.html';

					this.showMapLabelL = true;
					this.showMapLabelR = false;
					this.mapLabelL = '液状化';
					this.mapLabelR = '';
					break;
				case '3':
					console.log('シナリオ3 selected');
					this.showBtnBack = true;
					this.showBtnGo = true;
					this.showBtnGoSim = false;

					this.$emit('changeDoubleScreen', 'ON');
					this.$emit('changeInterlocking', 'ON');
					this.$emit('changeLeftLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$nextTick(function() {
						//this.$emit('changeRightLayer', {value:'L001', display:false, checkedLayers:[], checkedAllLayers:[]});
						this.$emit('changeRightLayer', {value:'L003', display:true, checkedLayers:[], checkedAllLayers:[]});
						this.$emit('changeRightLayer', {value:'L121', display:false, checkedLayers:[], checkedAllLayers:[]});
					});
					this.$emit('changeLeftLayer', {value:'L100', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L110', display:false, checkedLayers:[], checkedAllLayers:[]});

					this.showMapLabelL = false;
					this.showMapLabelR = true;
					this.mapLabelL = '';
					this.mapLabelR = '過去の空中写真';
					break;
				case '4':
					console.log('シナリオ4 selected');
					this.showBtnBack = true;
					this.showBtnGo = true;
					this.showBtnGoSim = false;

					this.$emit('changeDoubleScreen', 'ON');
					this.$emit('changeInterlocking', 'ON');
					this.$emit('changeLeftLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$nextTick(function() {
						this.$emit('changeRightLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
						//this.$emit('changeRightLayer', {value:'L003', display:false, checkedLayers:[], checkedAllLayers:[]});
						this.$emit('changeRightLayer', {value:'L121', display:true, checkedLayers:[], checkedAllLayers:[]});
						this.$emit('centerGetRight');
					});
					this.$emit('changeLeftLayer', {value:'L100', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L110', display:false, checkedLayers:[], checkedAllLayers:[]});

					this.legendParamR.title = '土地条件凡例';
					this.legendParamR.size = [240, 300];
					this.legendParamR.url = 'legend/landForm.html';

					this.showMapLabelL = false;
					this.showMapLabelR = true;
					this.mapLabelL = '';
					this.mapLabelR = '土地条件図';
					break;
				case '5':
					console.log('シナリオ5 selected');
					this.showBtnBack = true;
					this.showBtnGo = true;
					this.showBtnGoSim = false;

					this.$emit('changeDoubleScreen', 'ON');
					this.$emit('changeInterlocking', 'ON');
					this.$emit('changeLeftLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$nextTick(function() {
						this.$emit('changeRightLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
						//this.$emit('changeRightLayer', {value:'L003', display:false, checkedLayers:[], checkedAllLayers:[]});
						this.$emit('changeRightLayer', {value:'L121', display:true, checkedLayers:[], checkedAllLayers:[]});
						this.$emit('centerGetRight');
					});
					this.$emit('changeLeftLayer', {value:'L110', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L100', display:true, checkedLayers:['L100'], checkedAllLayers:[]});

					this.legendParamL.title = '震度凡例';
					this.legendParamL.size = [230, 230];
					this.legendParamL.url = 'legend/si.html';
					this.legendParamR.title = '土地条件凡例';
					this.legendParamR.size = [240, 300];
					this.legendParamR.url = 'legend/landForm.html';

					this.showMapLabelL = true;
					this.showMapLabelR = true;
					this.mapLabelL = '震度';
					this.mapLabelR = '土地条件図';
					break;
				case '6':
					console.log('シナリオ6 selected');
					this.showBtnBack = true;
					this.showBtnGo = true;
					this.showBtnGoSim = false;

					this.$emit('changeDoubleScreen', 'ON');
					this.$emit('changeInterlocking', 'ON');
					this.$emit('changeLeftLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$nextTick(function() {
						this.$emit('changeRightLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
						//this.$emit('changeRightLayer', {value:'L003', display:false, checkedLayers:[], checkedAllLayers:[]});
						this.$emit('changeRightLayer', {value:'L121', display:true, checkedLayers:[], checkedAllLayers:[]});
						this.$emit('centerGetRight');
					});
					this.$emit('changeLeftLayer', {value:'L100', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L110', display:true, checkedLayers:['L110'], checkedAllLayers:[]});

					this.legendParamL.title = '液状化危険度凡例';
					this.legendParamL.size = [230, 210];
					this.legendParamL.url = 'legend/pl.html';
					this.legendParamR.title = '土地条件凡例';
					this.legendParamR.size = [240, 300];
					this.legendParamR.url = 'legend/landForm.html';

					this.showMapLabelL = true;
					this.showMapLabelR = true;
					this.mapLabelL = '液状化';
					this.mapLabelR = '土地条件図';
					break;
				case '7':
					console.log('シナリオ7 selected');
					this.showBtnBack = true;
					this.showBtnGo = false;
					this.showBtnGoSim = true;

					this.$emit('changeDoubleScreen', 'OFF');
					this.$emit('changeLeftLayer', {value:'L001', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L100', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L110', display:false, checkedLayers:[], checkedAllLayers:[]});

					this.showMapLabelL = false;
					this.showMapLabelR = false;
					this.mapLabelL = '';
					this.mapLabelR = '';
					break;
			}
		},
		scenarioBack: function() {
			this.selected--;
			this.selected = String(this.selected);
			this.changeScenario();
		},
		scenarioGo: function() {
			this.selected++;
			this.selected = String(this.selected);
			this.changeScenario();
		},
		simGo: function(){
			//中心点の震度取得
			this.$emit('centerGetLeft');
			
			//震度の値取得
			console.log("si value : "+this.mapData.si);
			if (this.mapData.si) {
				if(confirm("地図の中心地点で建物倒壊シミュレータ（選択式）を開始しますか？")) {
					var href = this.simSelectUrl + "qsim.php?si="+ this.mapData.si;
					window.open(href, "_blank");
				}
			}
		},
		showLegendL: function() {
			if (legendWinL) {
				legendWinL.hide();
			}
			legendWinL = jsFrame.create({
				name: 'legend_win_l',
				title: this.legendParamL.title,
				left: 20, top: 20, width: this.legendParamL.size[0], height: this.legendParamL.size[1],
				movable: true,
				resizable: true,
				url: this.legendParamL.url
			}).show();
		},
		showLegendR: function() {
			if (this.selected !== '3') {
				if (legendWinR) {
					legendWinR.hide();
				}
				legendWinR = jsFrame.create({
					name: 'legend_win_r',
					title: this.legendParamR.title,
					width: this.legendParamR.size[0], height: this.legendParamR.size[1],
					movable: true,
					resizable: true,
					url: this.legendParamR.url
				});
				var x = window.innerWidth - 260;
				legendWinR.setPosition(x, 20, 'LEFT_TOP');
				legendWinR.show();
			}
		}
	},
	computed: {
		//シナリオ解説文の表示
		scenarioText: function() {
			var text = '';
			switch (this.selected) {
				case '0':
					text = 'まずは地図をドラッグしたり、ズームしたりして、地図の中心を調べたい場所に合わせてください。<br>使い方が分からないときは、画面右下にある各種メニューの、「地図の使い方」を参考にしてください。';
					break;
				case '1':
					if (this.mapData.si > 0) {
						var SI = '';
						if(this.mapData.si >= 6.5) { SI = "震度7" } else
						if(this.mapData.si >= 6.0 && this.mapData.si < 6.5) { SI = "震度6強" } else
						if(this.mapData.si >= 5.5 && this.mapData.si < 6.0) { SI = "震度6弱" } else
						if(this.mapData.si >= 5.0 && this.mapData.si < 5.5) { SI = "震度5強" } else
						if(this.mapData.si >= 4.5 && this.mapData.si < 5.0) { SI = "震度5弱" } else
						if(this.mapData.si >= 3.5 && this.mapData.si < 4.5) { SI = "震度4" } else
						if(SI < 3.5) { SI = "震度3以下" }
						text = '地図の中心付近は<span style="color:#FF0000"><b>' + SI + '</b></span>です。周りと比べて、安全でしょうか？それともよく揺れるでしょうか？<br>後で、震度の違いの理由を考えます。';
					} else {
						text = '地図の中心位置にはデータがありませんでした。場所を移動してください。';
					}
					break;
				case '2':
					if (this.mapData.pl !== "") {//「0」はtrueにしたいが、空文字はfalseにしたい
						var PL = '';
						if(this.mapData.pl > 15.0) { PL = "極めて高い" } else
						if(this.mapData.pl > 5.0 && this.mapData.pl <= 15.0) { PL = "高い" } else
						if(this.mapData.pl > 0   && this.mapData.pl <= 5.0)  { PL = "低い" } else
						if(this.mapData.pl > -1  && this.mapData.pl <= 0)    { PL = "極めて低い" } else
						if(this.mapData.pl > -2  && this.mapData.pl <= -1)   { PL = "計算対象層無し" } else
						if(this.mapData.pl <= -2) { PL = "計算対象外" }
						text = '地図の中心付近の液状化危険度は<span style="color:#FF0000"><b>' + PL + '</b></span>です。周りと比べて、安全でしょうか？<br>後で、この液状化危険度になる理由を考えます。';
					} else {
						text = '地図の中心位置にはデータがありませんでした。場所を移動してください。';
					}
					break;
				case '3':
					text = '現在の地図と過去の空中写真を見比べて、調べたい場所が昔どのような様子だったかを見てみましょう。<br>昔は丘だったでしょうか？川や池だったでしょうか？それとも昔から住宅地だったでしょうか？';
					break;
				case '4':
				case '5':
				case '6':
					var landCondition = '';
					if (this.mapData2.comment_q) {
						landCondition = this.mapData2.comment_q;
					} else {
						//landCondition = '土地条件データが有りません。';
						landCondition = '地図の中心位置にはデータがありませんでした。場所を移動してください。';
					}
					text = '地図の中心付近は' + landCondition;
					break;
				case '7':
					//text = '地図をドラッグしたり、ズームしたりして、地図の中心をシミュレーションしたい場所（ご自宅の位置）に合わせてください。地図を合わせてから、マップ中央上の「建物倒壊シミュレータへ進む」ボタンを押してください。';
					if (this.mapData.si) {
						text = '地図をドラッグしたり、ズームしたりして、地図の中心をシミュレーションしたい場所（ご自宅の位置）に合わせてください。<br>'
							+'地図を合わせてから、マップ中央上の「建物倒壊シミュレータ（選択式）へ進む」ボタンを押してください。';
					}else{
						text = '地図の中心位置に震度データがありません。<br>愛知県内のエリアに移動してからマップ中央上の「建物倒壊シミュレータ（選択式）へ進む」ボタンを押してください。';
					}
					break;
			}
			return text;
		},
	}
}
</script>

<style scoped>
@import "../../css/ScenarioSelect.css";
</style>
